import Keycloak from 'keycloak-js'
import { environment } from '../../enviroments/enviroment'

const keycloakOptions = {
  url: environment.keycloak.url,
  realm: environment.keycloak.realm,
  clientId: environment.keycloak.client,
}

const initOptions = {
  onLoad: 'check-sso',
  pkceMethod: 'S256',
  silentCheckSsoRedirectUri: `${window.location.origin}${environment.publicUrl}/silent-check-sso.html`,
}

const keycloak = new Keycloak(keycloakOptions)

// Initialize Keycloak
const keycloakInit = callback => {
  keycloak.init(initOptions).then(() => {
    callback()
  })
}

// Keycloak functions
const login = keycloak.login // Redirect to login page
const logout = keycloak.logout
const getToken = () => keycloak.token
const updateToken = callback => keycloak.updateToken(5).then(callback).catch(login)
const getUsername = () => keycloak.tokenParsed?.username
// Temporary workaround - fixed in #154
// const hasRole = (roles: string[]) => roles.some(role => keycloak.hasRealmRole(role))
const hasRole = roles => true

const isLoggedIn = () => !!keycloak.token
const getTokenDecoded = () => keycloak.tokenParsed
const isTokenExpired = () => {
  return keycloak.isTokenExpired()
}

const UserService = {
  keycloakInit,
  login,
  logout,
  getToken,
  updateToken,
  getUsername,
  hasRole,
  isLoggedIn,
  getTokenDecoded,
  isTokenExpired,
}

export default UserService
